import { Dispatch } from "redux";
import { ApiService } from "../../../../services/apiService";
import { handleRequestErrors } from "../../../../shared/utils";
import { routes } from "../../../../services/paths";
import { appConstants } from "../../../action-constants/inapp.constants";
import {
  CreateStoreGroupPayload,
  GetStoreGroupsResponse,
  StoreGroupDeleteResponse,
  StoreGroupDetail,
  StoreGroupMutationResponse,
  UpdateStoreGroupPayload,
} from "../../../../types/app/storeGroupsTypes";

export const GetStoreGroups = (actionPayload: string | "CLEAR") => {
  if (actionPayload !== "CLEAR") {
    return (dispatch: Dispatch) => {
      const apiConsume = ApiService.request({
        url: `${routes.STORE_GROUPS}?${actionPayload}`,
        http_method: "GET",
      });

      dispatch(request(apiConsume));

      return apiConsume
        .then((response: any) => dispatch(success(response.data)))
        .catch((error: any) => dispatch(failure(handleRequestErrors(error))));
    };
  }

  return (dispatch: Dispatch) => dispatch(clear());

  function request(params: any) {
    return { type: appConstants.GET_STORE_GROUPS_PENDING, params };
  }
  function success(response: GetStoreGroupsResponse) {
    return { type: appConstants.GET_STORE_GROUPS_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: appConstants.GET_STORE_GROUPS_FAILURE, error };
  }
  function clear() {
    return { type: appConstants.GET_STORE_GROUPS_RESET, clear_data: "" };
  }
};

export const GetStoreGroup = (actionPayload: string | "CLEAR", id?: string) => {
  if (actionPayload !== "CLEAR") {
    return (dispatch: Dispatch) => {
      const apiConsume = ApiService.request({
        url: `${routes.STORE_GROUPS}/${id}`,
        http_method: "GET",
      });

      dispatch(request(apiConsume));
      return apiConsume
        .then((response: any) => dispatch(success(response.data)))
        .catch((error: any) => dispatch(failure(handleRequestErrors(error))));
    };
  }

  return (dispatch: Dispatch) => dispatch(clear());

  function request(params: any) {
    return { type: appConstants.GET_STORE_GROUP_PENDING, params };
  }
  function success(response: StoreGroupDetail) {
    return { type: appConstants.GET_STORE_GROUP_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: appConstants.GET_STORE_GROUP_FAILURE, error };
  }
  function clear() {
    return { type: appConstants.GET_STORE_GROUP_RESET };
  }
};

export const CreateStoreGroup = (
  actionPayload: CreateStoreGroupPayload | "CLEAR"
) => {
  if (actionPayload != "CLEAR") {
    return (dispatch: Dispatch) => {
      const apiConsume = ApiService.request({
        url: routes.STORE_GROUPS,
        http_method: "POST",
        data: actionPayload,
      });

      dispatch(request(apiConsume));
      return apiConsume
        .then((response: any) => dispatch(success(response.data)))
        .catch((error: any) => dispatch(failure(handleRequestErrors(error))));
    };
  }
  return (dispatch: Dispatch) => dispatch(clear());

  function request(params: any) {
    return { type: appConstants.CREATE_STORE_GROUP_PENDING, params };
  }
  function success(response: StoreGroupMutationResponse) {
    return { type: appConstants.CREATE_STORE_GROUP_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: appConstants.CREATE_STORE_GROUP_FAILURE, error };
  }
  function clear() {
    return { type: appConstants.CREATE_STORE_GROUP_RESET };
  }
};

export const UpdateStoreGroup = (
  actionPayload: UpdateStoreGroupPayload | "CLEAR"
) => {
  if (actionPayload !== "CLEAR") {
    return (dispatch: Dispatch) => {
      const apiConsume = ApiService.request({
        url: `${routes.STORE_GROUPS}`,
        http_method: "PUT",
        data: actionPayload,
      });

      dispatch(request(apiConsume));
      return apiConsume
        .then((response: any) => dispatch(success(response.data)))
        .catch((error: any) => dispatch(failure(handleRequestErrors(error))));
    };
  }
  return (dispatch: Dispatch) => dispatch(clear());

  function request(params: any) {
    return { type: appConstants.UPDATE_STORE_GROUP_PENDING, params };
  }
  function success(response: StoreGroupMutationResponse) {
    return { type: appConstants.UPDATE_STORE_GROUP_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: appConstants.UPDATE_STORE_GROUP_FAILURE, error };
  }
  function clear() {
    return { type: appConstants.UPDATE_STORE_GROUP_RESET };
  }
};
export const DeleteStoreGroup = (
  actionPayload: string | "CLEAR",
  id: string
) => {
  if (actionPayload != "CLEAR") {
    return (dispatch: Dispatch) => {
      const apiConsume = ApiService.request({
        url: `${routes.STORE_GROUPS}/${id}`,
        http_method: "DELETE",
      });

      dispatch(request(apiConsume));
      return apiConsume
        .then((response: any) => dispatch(success(response.data)))
        .catch((error: any) => dispatch(failure(handleRequestErrors(error))));
    };
  }
  return (dispatch: Dispatch) => dispatch(clear());

  function failure(error: any) {
    return { type: appConstants.DELETE_STORE_GROUP_FAILURE, error };
  }
  function request(params: any) {
    return { type: appConstants.DELETE_STORE_GROUP_PENDING, params };
  }
  function success(response: StoreGroupDeleteResponse) {
    return { type: appConstants.DELETE_STORE_GROUP_SUCCESS, response };
  }
  function clear() {
    return { type: appConstants.DELETE_STORE_GROUP_RESET };
  }
};

export const GetStoreCategories = (actionPayload: string | "CLEAR") => {
  if (actionPayload !== "CLEAR") {
    return (dispatch: Dispatch) => {
      const apiConsume = ApiService.request({
        url: `${routes.CATEGORIES}?${actionPayload}`,
        http_method: "GET",
      });

      dispatch(request(apiConsume));

      return apiConsume
        .then((response: any) => dispatch(success(response.data)))
        .catch((error: any) => dispatch(failure(handleRequestErrors(error))));
    };
  }

  return (dispatch: Dispatch) => dispatch(clear());

  function request(params: any) {
    return { type: appConstants.GET_STORE_CATEGORIES_PENDING, params };
  }
  function success(response: any) {
    return { type: appConstants.GET_STORE_CATEGORIES_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: appConstants.GET_STORE_CATEGORIES_FAILURE, error };
  }
  function clear() {
    return { type: appConstants.GET_STORE_CATEGORIES_RESET, clear_data: "" };
  }
};

export const GetStoreCategory = (
  actionPayload: string | "CLEAR",
  id: string
) => {
  if (actionPayload !== "CLEAR") {
    return (dispatch: Dispatch) => {
      const apiConsume = ApiService.request({
        url: `${routes.CATEGORIES}/${id}`,
        http_method: "GET",
      });

      dispatch(request(apiConsume));
      return apiConsume
        .then((response: any) => dispatch(success(response.data)))
        .catch((error: any) => dispatch(failure(handleRequestErrors(error))));
    };
  }

  return (dispatch: Dispatch) => dispatch(clear());

  function request(params: any) {
    return { type: appConstants.GET_STORE_CATEGORY_PENDING, params };
  }
  function success(response: any) {
    return { type: appConstants.GET_STORE_CATEGORY_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: appConstants.GET_STORE_CATEGORY_FAILURE, error };
  }
  function clear() {
    return { type: appConstants.GET_STORE_CATEGORY_RESET };
  }
};

export const CreateStoreCategory = (
  actionPayload: { name: string } | "CLEAR"
) => {
  if (actionPayload != "CLEAR") {
    return (dispatch: Dispatch) => {
      const apiConsume = ApiService.request({
        url: routes.CATEGORIES,
        http_method: "POST",
        data: actionPayload,
      });

      dispatch(request(apiConsume));
      return apiConsume
        .then((response: any) => dispatch(success(response.data)))
        .catch((error: any) => dispatch(failure(handleRequestErrors(error))));
    };
  }
  return (dispatch: Dispatch) => dispatch(clear());

  function request(params: any) {
    return { type: appConstants.CREATE_STORE_CATEGORY_PENDING, params };
  }
  function success(response: any) {
    return { type: appConstants.CREATE_STORE_CATEGORY_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: appConstants.CREATE_STORE_CATEGORY_FAILURE, error };
  }
  function clear() {
    return { type: appConstants.CREATE_STORE_CATEGORY_RESET };
  }
};

export const UpdateStoreCategory = (
  actionPayload: { id: number; name: string } | "CLEAR"
) => {
  if (actionPayload != "CLEAR") {
    return (dispatch: Dispatch) => {
      const apiConsume = ApiService.request({
        url: `${routes.CATEGORIES}`,
        http_method: "PUT",
        data: actionPayload,
      });

      dispatch(request(apiConsume));
      return apiConsume
        .then((response: any) => dispatch(success(response.data)))
        .catch((error: any) => dispatch(failure(handleRequestErrors(error))));
    };
  }
  return (dispatch: Dispatch) => dispatch(clear());

  function request(params: any) {
    return { type: appConstants.UPDATE_STORE_CATEGORY_PENDING, params };
  }
  function success(response: any) {
    return { type: appConstants.UPDATE_STORE_CATEGORY_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: appConstants.UPDATE_STORE_CATEGORY_FAILURE, error };
  }
  function clear() {
    return { type: appConstants.UPDATE_STORE_CATEGORY_RESET };
  }
};

export const DeleteStoreCategory = (id: number, actionPayload: "CLEAR") => {
  if (actionPayload != "CLEAR") {
    return (dispatch: Dispatch) => {
      const apiConsume = ApiService.request({
        url: `${routes.CATEGORIES}/${id}`,
        http_method: "DELETE",
      });

      dispatch(request(apiConsume));
      return apiConsume
        .then((response: any) => dispatch(success(response.data)))
        .catch((error: any) => dispatch(failure(handleRequestErrors(error))));
    };
  }
  return (dispatch: Dispatch) => dispatch(clear());

  function request(params: any) {
    return { type: appConstants.DELETE_STORE_CATEGORY_PENDING, params };
  }
  function success(response: any) {
    return { type: appConstants.DELETE_STORE_CATEGORY_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: appConstants.DELETE_STORE_CATEGORY_FAILURE, error };
  }
  function clear() {
    return { type: appConstants.DELETE_STORE_CATEGORY_RESET };
  }
};
